import React, { useState, useMemo } from 'react';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import { Card } from './ui/card';
import { GOOGLE_MAPS_LOADER_OPTIONS } from '../lib/googleMapsLoader';

const containerStyle = { width: '100%', height: '420px', borderRadius: '12px' };
const defaultCenter = { lat: 19.4326, lng: -99.1332 }; // CDMX

const CarMap = ({ cars = [], onMarkerClick }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);
  const [selected, setSelected] = useState(null);

  const markers = useMemo(() => {
    return cars
      .filter(c => c.lat && c.lng)
      .map(c => ({ ...c, position: { lat: Number(c.lat), lng: Number(c.lng) } }));
  }, [cars]);

  if (!apiKey || loadError) {
    return (
      <Card className="p-6 text-center text-sm text-gray-600">
        Mapa no disponible. {loadError?.message || ''}
      </Card>
    );
  }
  if (!isLoaded) {
    return <Card className="p-6 text-center text-sm text-gray-500">Cargando mapa...</Card>;
  }

  const center = markers[0]?.position || defaultCenter;

  return (
    <div data-testid="car-map">
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={11}>
        {markers.map((m) => (
          <Marker
            key={m.id}
            position={m.position}
            onClick={() => setSelected(m)}
          />
        ))}
        {selected && (
          <InfoWindow
            position={selected.position}
            onCloseClick={() => setSelected(null)}
          >
            <div
              className="cursor-pointer"
              onClick={() => onMarkerClick?.(selected)}
              data-testid={`map-info-${selected.id}`}
            >
              <p className="font-medium text-gray-900">{selected.name}</p>
              <p className="text-sm text-gray-600">${selected.price_per_day} MXN/día</p>
              <p className="text-xs text-blue-600 underline mt-1">Ver detalles →</p>
            </div>
          </InfoWindow>
        )}
        {markers.length === 0 && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/80 pointer-events-none">
            <p className="text-sm text-gray-600">No hay autos con ubicación geolocalizada</p>
          </div>
        )}
      </GoogleMap>
    </div>
  );
};

export default CarMap;
